import moment from 'moment';

export const LocationPickerComponent = {
    template: `
        <p>Where are you located?</p>
        <div class="location-picker-row">
            <geo-autocomplete
                use-mapbox="$ctrl.useMapbox"
                ng-if="!$ctrl.loading"
                initial-address="$ctrl.initialAddress"
                stored-addresses="$ctrl.savedAddresses"
                on-geolocation-error="$ctrl.onGeolocationError(error)"
                on-address-selection="$ctrl.onAddressSelection(address)"></geo-autocomplete>
            <button
                id="go-button"
                class="button button-primary"
                type="button"
                ng-click="$ctrl.tryGetNearbyRestaurants()">Go</button>
        </div>
        <oo-alert ng-if="$ctrl.errorMessage" severity="warning">
            <oo-alert-message>{{$ctrl.errorMessage}}</oo-alert-message>
        </oo-alert>
    `,
    controller: class {
        constructor($scope, consumerService, restaurantService, accountService, localStorageService, LOCAL_STORAGE, DINING_OPTION) {
            'ngInject';
            this.$scope = $scope;
            this.consumerService = consumerService;
            this.restaurantService = restaurantService;
            this.accountService = accountService;
            this.localStorageService = localStorageService;
            this.LOCAL_STORAGE = LOCAL_STORAGE;
            this.DINING_OPTION = DINING_OPTION;
            this.useMapbox = true;
        }

        $onInit() {
            this.accountService.getAddresses()
                .then(() => this._getSavedAddresses())
                .finally(() => this.loading = false);
            this._setInitialAddress();
            this.loading = true;

            this.$scope.$watch(
                () => this.consumerService.data.diningOption,
                () => {
                    this.errorMessage = null;
                }
            );
        }

        _setInitialAddress() {
            let savedAddress = this.consumerService.getLocation();
            if(!!savedAddress.latitude && !!savedAddress.longitude) {
                this.initialAddress = savedAddress;
                this.initialAddress.isSavedAddress = true;
                this.onAddressSelection(this.initialAddress);
            }
        }

        _getSavedAddresses() {
            let addresses = this.accountService.data.addresses;
            this.savedAddresses = addresses.map(a => {
                let addr = Object.assign({}, a);
                addr.description = `${a.name}: ${a.address1}`;
                addr.isSavedAddress = true;
                return addr;
            });
        }

        onAddressSelection(address) {
            address.streetAddress1 = address.address1;
            address.streetAddress2 = address.streetAddress2;
            this.consumerService.setLocation(
                address.latitude,
                address.longitude,
                { fromLocalStorage: true }
            );
            address.dateTime = moment().toISOString();
            this.localStorageService.set(this.LOCAL_STORAGE.ADDRESS, address);
            this.tryGetNearbyRestaurants();
        }

        tryGetNearbyRestaurants() {
            this.errorMessage = null;

            const address = this.consumerService.getLocation();
            if (this.consumerService.getDiningOption() === this.DINING_OPTION.DELIVERY && !address.address1) {
                this.restaurantService.clearNearbyRestaurants();
                this.onGeolocationError({
                    message: 'Please provide a complete street address for more accurate results'
                });
                return;
            }

            this.restaurantService.getNearbyRestaurants();
        }

        onGeolocationError(error) {
            this.errorMessage = error.message;
        }
    }
};
